import { Outlet } from "react-router";
import { Box } from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import { useDispatch } from "react-redux";

import Sidebar from "../sidebar";
import LogoLoader from "../commonComponents/LogoLoader";

import useAuth from "../../hooks/useAuth";
import useConfig from "../../hooks/useConfig";
import useSubscriptionMonitor from "../../hooks/useSubscriptionMonitor";

import { MainLayoutWrapper } from "../../pageComponents/auth/style";
import { AccountSagaActions } from "../../store/account/sagas";
import { PaymentSagaActions } from "../../store/payment/sagas";
import { MetaDataSagaActions } from "../../store/metadata/sagas";

const MainLayout = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();
  const { drawerOpen } = useConfig();
  const [loading, setLoading] = useState(false);

  // ✅ Cached user details for stable reference
  const userDetails = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("User") || "null");
    } catch {
      return null;
    }
  }, []);

  useSubscriptionMonitor();

  useEffect(() => {
    if (!isAuthenticated) return;
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timeout);
  }, [isAuthenticated]);

  // ✅ Fetch user & subscription data (only once per login session)
  useEffect(() => {
    if (!isAuthenticated || !userDetails?._id) return;

    dispatch(AccountSagaActions.fetchUserDetails(userDetails._id));
    dispatch(PaymentSagaActions.fetchActiveSubscription());
  }, [dispatch, isAuthenticated, userDetails?._id]);

  useEffect(() => {
    if (!isAuthenticated) return;

    dispatch(MetaDataSagaActions.checkNotification()); // initial call
    const interval = setInterval(() => {
      dispatch(MetaDataSagaActions.checkNotification());
    }, 60000); // every 60s

    return () => clearInterval(interval);
  }, [dispatch, isAuthenticated]);

  if (loading) return <LogoLoader />;

  return (
    <Box
      sx={{
        display: "flex",
        height: "100dvh",
      }}
    >
      {isAuthenticated && <Sidebar />}
      <MainLayoutWrapper drawerOpen={drawerOpen} id="content">
        <Outlet />
      </MainLayoutWrapper>
    </Box>
  );
};

export default MainLayout;
